<template>
  <v-list dense three-line class="transparent">
    <template v-for="activity in activities">
      <v-list-item :key="`activity-${activity.id}`" class="list__tile--free-height">
        <v-list-item-content>
          <v-list-item-title class="overline">
            {{ activity.created_at | moment('DD/MM/YYYY HH:mm') }}
          </v-list-item-title>
          <v-list-item-title class="body-1">
            <strong>{{ activity.causer_name }}</strong> {{ activity.description }} {{ activity.subject_type }}
            <strong>{{ activity.subject_name }}</strong>
          </v-list-item-title>
          <v-list-item-subtitle class="text--primary" v-if="activity.description === 'updated'">
            <v-row>
              <v-col>
                <div class="font-weight-bold mb-1">New:</div>
                <div
                  v-for="(value, field) in activity.properties.attributes"
                  :key="'new-attribute' + field + value"
                  class="mb-1"
                >
                  <strong>{{ field | titleCase }}: </strong>{{ value }}
                </div>
              </v-col>
              <v-col class="text--secondary">
                <div class="font-weight-bold mb-1">Old:</div>
                <div
                  v-for="(value, field) in activity.properties.old"
                  :key="'old-attribute' + field + value"
                  class="mb-1"
                >
                  <strong>{{ field | titleCase }}: </strong> {{ value }}
                </div>
              </v-col>
            </v-row>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider :key="`divider-${activity.id}`"></v-divider>
    </template>
  </v-list>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'activity-list',
  props: ['activities'],
  filters: {
    titleCase: function(string) {
      return _.words(string)
        .map(word => (word.length !== 3 ? _.capitalize(word) : word))
        .reduce((carry, word) => carry + ' ' + word, '');
    }
  }
};
</script>

<style lang="scss" scoped>
.list__tile--free-height {
  ::v-deep .list__tile {
    height: auto;
    min-height: 76px;
    padding: {
      top: 5px;
      bottom: 5px;
    }
    align-items: flex-start;
  }
}

::v-deep .list__tile__sub-title {
  -webkit-line-clamp: unset;
}
</style>
